import {
  basePostQuery,
  createGuest,
  updateCustomerProfile,
} from '../../../../utility/sb-api/sb-api.service';
import {
  createHash,
  getOrderBody,
  getOrderPathType,
} from '../../../../utility/util/util.service';

export const updateCartItemQty = (
  updateCartItem,
  cart,
  hash,
  increase = true,
  checkout,
) =>
  updateCartItem(
    cart,
    hash,
    (item) => ({
      ...item,
      qty: increase ? item.qty + 1 : item.qty - 1,
    }),
    checkout,
  );

export const createOrder = (
  me,
  order,
  checkout,
  cart,
  store,
  setOrder,
  setOrderHash,
  fetchOnAuthenticated,
  intl,
  table,
  kiosk,
  setWebSocketToken,
) => {
  if (checkout) {
    const type = getOrderPathType(checkout.orderType);

    // if there is no me object (= anonymous user) create a guest account first
    return (
      (me
        ? Promise.resolve()
        : createGuest({ language: intl?.locale }, setWebSocketToken).then(() =>
            fetchOnAuthenticated(),
          )
      )
        // create the Order
        .then(() =>
          basePostQuery(
            `orders/${type}`,
            getOrderBody(
              checkout,
              cart,
              table,
              store.merchantProfile.id,
              kiosk,
            ),
          ),
        )
        .then((order) => {
          // update the CustomerProfile if any property has changed (fire & forget)
          const customerProfile = me.requester.customerProfile;
          if (
            checkout.name !== customerProfile.name ||
            checkout.tel !== customerProfile.tel ||
            checkout.email !== customerProfile.email
          ) {
            updateCustomerProfile(customerProfile.id, {
              name: checkout.customerName,
              tel: checkout.customerTel,
              email: checkout.customerEmail,
            }).then(() => fetchOnAuthenticated());
          }

          // create hash of the Order to track changes
          const hash = createHash({ cart, checkout });
          setOrderHash(hash);
          setOrder(order);

          return order;
        })
    );
  } else {
    return Promise.reject('Checkout missing or empty');
  }
};

export const buildOrderItemByIds = (menuEntriesData, orderItem) => {
  const itemData = menuEntriesData?.find(
    ({ id, type }) => type !== 'ItemCategory' && id === orderItem.itemDataId,
  );

  const allFilteredAdditions =
    itemData?.additionGroups?.flatMap((group) =>
      (orderItem.additions || [])
        .filter(({ additionGroupEntryId }) =>
          group.entries?.some((entry) => entry.id === additionGroupEntryId),
        )
        .map(({ additionGroupEntryId }) =>
          group.entries.find((entry) => entry.id === additionGroupEntryId),
        )
        .map((entry) => ({ ...entry, group })),
    ) ?? [];

  return {
    qty: orderItem?.qty,
    itemData,
    additions:
      allFilteredAdditions?.map((additionEntry) => {
        return {
          additionGroupEntry: additionEntry,
          qty: 1,
        };
      }) || null,
  };
};
